import { ComponentProps } from 'react';
import styled from 'styled-components';

const Container = styled.span<{ color: string }>`
	color: ${(props) => props.theme.colors[props.color]};
`;

export function Color(props: ComponentProps<typeof Container>) {
	return <Container {...props} />;
}

export const IconColor = styled.span<{ color: string }>`
	svg path {
		fill: ${(props) => props.theme.colors[props.color]};
	}
`;

Color.Icon = IconColor;
